import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  ActionIcon,
  Loading,
  PaginatedTable,
  TextField,
  DateTimePickerInput,
  DropdownInput,
  Snackbar,
  CustomDrawer,
} from "components";
import { getTableDisplayConfig } from "displayConfigs";
import { LANGUAGE_OPTIONS } from "constants";
import { generateQueryParamsFromObject } from "utils";
import { useSnackbar } from "hooks";
import MemeSuggestionDetail from "./MemeSuggestionDetail";
import "./index.css";
import "./mobile.css";
import "./tablet.css";

const MemeSuggestionsListPage = () => {
  const snackbar = useSnackbar();
  const [adminMemeSuggestionsList, setAdminMemeSuggestionsList] = useState([]);
  const [selectedMemeSuggestion, setSelectedMemeSuggestion] = useState();
  const [loading, setLoading] = useState(false);
  const [searchFilters, setSearchFilters] = useState();

  useEffect(() => {
    fetchMemeSuggestionsList();
  }, [searchFilters]);

  const memeSuggestionConfig = getTableDisplayConfig("MemeSuggestion", {
    actions: (rowVal) => (
      <>
        <ActionIcon
          type="view"
          iconClassName="listIcon"
          onClick={() => setSelectedMemeSuggestion(rowVal)}
        />
      </>
    ),
  });

  const fetchMemeSuggestionsList = async () => {
    try {
      setLoading(true);
      const query = generateQueryParamsFromObject(searchFilters || {});
      const { memeSuggestionsList } = await memeSuggestionConfig.fetchListData(
        query
      );
      setLoading(false);
      setAdminMemeSuggestionsList(memeSuggestionsList);
    } catch (err) {
      setLoading(false);
      snackbar.showMessage({
        content: err,
      });
      setAdminMemeSuggestionsList([]);
    }
  };

  const handleSearchFiltersChange = (key, value) => {
    setSearchFilters({
      ...searchFilters,
      [key]: value,
    });
  };

  const { header } = memeSuggestionConfig;
  const { searchTerm, fromDate, toDate, category, status } =
    searchFilters || {};

  return (
    <>
      <Snackbar {...snackbar} />
      {loading && <Loading />}
      <div className="admin__memeSuggestionsList">
        {header}
        <div className="admin__memeSuggestionsList__filters">
          <div className="div__searchInput">
            <TextField
              className="admin__memeSuggestionsList__searchInput"
              placeholder="Search by Meme Name or consumer name"
              value={searchTerm || ``}
              onChange={({ target }) =>
                handleSearchFiltersChange("searchTerm", target.value)
              }
            />
          </div>
          <div className="div_Filters">
            <DateTimePickerInput
              inputType="Date"
              className="admin__memeSuggestionsList__fromDate"
              placeholder="From"
              dateValue={fromDate || null}
              handleChange={(dateVal) =>
                handleSearchFiltersChange("fromDate", dateVal?._d.toISOString())
              }
            />
            <DateTimePickerInput
              inputType="Date"
              className="admin__memeSuggestionsList__toDate"
              dateValue={toDate || null}
              placeholder="To"
              handleChange={(dateVal) =>
                handleSearchFiltersChange("toDate", dateVal?._d.toISOString())
              }
            />
            <DropdownInput
              className="admin__memeSuggestionsList__status"
              placeholder="Meme Status"
              optionsList={[]}
              selectedOption={status || "Meme Status"}
              onSelect={({ target }) =>
                handleSearchFiltersChange("status", target.value)
              }
            />
            <DropdownInput
              className="admin__memeSuggestionsList__category"
              optionsList={LANGUAGE_OPTIONS.map((language) => ({
                label: language,
                value: language,
              }))}
              placeholder="Language"
              selectedOption={category || "Language"}
              onSelect={({ target }) =>
                handleSearchFiltersChange("language", target.value)
              }
            />
          </div>
        </div>
        <PaginatedTable
          config={memeSuggestionConfig}
          dataList={adminMemeSuggestionsList}
        />
        <CustomDrawer
          direction="bottom"
          className="admin__memeSuggestionsList__memeSuggestionDrawer--view"
          isOpen={!_.isUndefined(selectedMemeSuggestion)}
          onCloseDrawer={() => setSelectedMemeSuggestion(undefined)}
        >
          {selectedMemeSuggestion && (
            <MemeSuggestionDetail
              memeSuggestionDetail={selectedMemeSuggestion}
              onCloseDrawer={() => setSelectedMemeSuggestion(undefined)}
            />
          )}
        </CustomDrawer>
      </div>
    </>
  );
};

export default MemeSuggestionsListPage;
